const a = {
  navigationColor: "--slidejs-navigation-color",
  paginationColor: "--slidejs-pagination-color",
  paginationActiveColor: "--slidejs-pagination-active-color",
  scrollbarBg: "--slidejs-scrollbar-bg",
  scrollbarDragBg: "--slidejs-scrollbar-drag-bg",
  arrowColor: "--slidejs-arrow-color",
  progressBarColor: "--slidejs-progress-bar-color",
  backgroundColor: "--slidejs-background-color",
  textColor: "--slidejs-text-color",
  linkColor: "--slidejs-link-color",
  headingColor: "--slidejs-heading-color",
  codeBackground: "--slidejs-code-background"
}, g = "solarized-dark", e = "solarized-light", d = {
  // 基础颜色
  backgroundColor: "#002b36",
  // base03 - 最暗的背景
  textColor: "#839496",
  // base0 - 主要文本
  headingColor: "#93a1a1",
  // base1 - 标题文本
  linkColor: "#268bd2",
  // blue - 链接颜色
  // 导航和分页
  navigationColor: "#268bd2",
  // blue - 导航按钮
  paginationColor: "#268bd2",
  // blue - 分页器
  paginationActiveColor: "#2aa198",
  // cyan - 激活状态
  arrowColor: "#268bd2",
  // blue - 箭头（Splide）
  progressBarColor: "#2aa198",
  // cyan - 进度条
  // 滚动条
  scrollbarBg: "rgba(131, 148, 150, 0.2)",
  // base0 with opacity
  scrollbarDragBg: "rgba(131, 148, 150, 0.5)",
  // base0 with opacity
  // 代码
  codeBackground: "#073642"
  // base02 - 代码背景
}, C = {
  // 基础颜色
  backgroundColor: "#fdf6e3",
  // base3 - 最亮的背景
  textColor: "#657b83",
  // base00 - 主要文本
  headingColor: "#586e75",
  // base01 - 标题文本
  linkColor: "#268bd2",
  // blue - 链接颜色
  // 导航和分页
  navigationColor: "#268bd2",
  // blue - 导航按钮
  paginationColor: "#268bd2",
  // blue - 分页器
  paginationActiveColor: "#2aa198",
  // cyan - 激活状态
  arrowColor: "#268bd2",
  // blue - 箭头（Splide）
  progressBarColor: "#2aa198",
  // cyan - 进度条
  // 滚动条
  scrollbarBg: "rgba(101, 123, 131, 0.2)",
  // base00 with opacity
  scrollbarDragBg: "rgba(101, 123, 131, 0.5)",
  // base00 with opacity
  // 代码
  codeBackground: "#eee8d5"
  // base2 - 代码背景
}, s = {
  [g]: d,
  [e]: C
}, b = {
  SolarizedDark: g,
  SolarizedLight: e
};
function i(r, o, l) {
  r instanceof Document ? r.documentElement.style.setProperty(o, l) : r.style.setProperty(o, l);
}
function t(r, o) {
  o.navigationColor && i(r, a.navigationColor, o.navigationColor), o.paginationColor && i(r, a.paginationColor, o.paginationColor), o.paginationActiveColor && i(
    r,
    a.paginationActiveColor,
    o.paginationActiveColor
  ), o.scrollbarBg && i(r, a.scrollbarBg, o.scrollbarBg), o.scrollbarDragBg && i(r, a.scrollbarDragBg, o.scrollbarDragBg), o.arrowColor && i(r, a.arrowColor, o.arrowColor), o.progressBarColor && i(r, a.progressBarColor, o.progressBarColor), o.backgroundColor && i(r, a.backgroundColor, o.backgroundColor), o.textColor && i(r, a.textColor, o.textColor), o.linkColor && i(r, a.linkColor, o.linkColor), o.headingColor && i(r, a.headingColor, o.headingColor), o.codeBackground && i(r, a.codeBackground, o.codeBackground);
}
class c {
  /**
   * 创建主题 Hook 实例
   *
   * @param target - 目标元素或文档（默认为 document）
   */
  constructor(o) {
    if (typeof o == "string") {
      const l = document.querySelector(o);
      if (!l)
        throw new Error(`Element not found: ${o}`);
      this.target = l;
    } else o ? this.target = o : this.target = document;
  }
  /**
   * 设置标准主题（高级 API）
   * 使用标准变量名，不针对特定 runner
   *
   * 这是 SlideJS 官方支持的 API
   *
   * @param theme - 标准主题配置或预设主题名称
   */
  set(o) {
    if (typeof o == "string") {
      const l = s[o];
      if (!l)
        throw new Error(
          `Unknown preset theme: ${o}. Available presets: ${Object.keys(s).join(", ")}`
        );
      t(this.target, l);
    } else
      t(this.target, o);
  }
  /**
   * 获取 CSS 变量值
   *
   * @param variableName - CSS 变量名（标准变量或 runner 特定变量）
   * @returns CSS 变量值
   */
  get(o) {
    return this.target instanceof Document ? getComputedStyle(this.target.documentElement).getPropertyValue(o).trim() : getComputedStyle(this.target).getPropertyValue(o).trim();
  }
  /**
   * 移除 CSS 变量
   *
   * @param variableName - CSS 变量名（标准变量或 runner 特定变量）
   */
  remove(o) {
    this.target instanceof Document ? this.target.documentElement.style.removeProperty(o) : this.target.style.removeProperty(o);
  }
  /**
   * 清除所有标准主题变量
   */
  clear() {
    Object.values(a).forEach((o) => {
      this.remove(o);
    });
  }
}
const n = new c();
function p(r) {
  if (typeof r == "string") {
    const o = s[r];
    if (!o)
      throw new Error(
        `Unknown preset theme: ${r}. Available presets: ${Object.keys(s).join(", ")}`
      );
    n.set(o);
  } else
    n.set(r);
}
function u(r) {
  return new c(r);
}
export {
  b as Preset,
  a as STANDARD_CSS_VARIABLES,
  c as SlideThemeHook,
  n as globalTheme,
  s as presets,
  p as setTheme,
  d as solarizedDark,
  C as solarizedLight,
  u as useTheme
};
//# sourceMappingURL=index.mjs.map
